import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import style from './KycPendingModal.module.scss';
import useClickAwayListener from '../../../hooks/useClickAwayLitsner';
import { getSourceValue } from '../../../lib/common';

const KycPendingModal = ({ setShowKycPopup, handleKycRedirect }) => {
  const kycModalRef = useRef(null);
  const source = getSourceValue();
  const queryParams = new URLSearchParams(window.location.search);
  const version = queryParams.get('version') ? parseFloat(queryParams.get('version') || '0') : 0;
  useClickAwayListener(kycModalRef, () => {
    setShowKycPopup(false);
  });

  return (
    <section className={`cs_modal ${style.Modal}`}>
      <div ref={kycModalRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${style.Modal__Content} `}>
        <div
          className="csgrievance_headtxt popup-heading-div font15 fw600 color111 pr-10 pt-10"
          style={{ justifyContent: 'flex-end' }}
        >
          <div
            className="modal_close csicon"
            onClick={() => {
              sessionStorage.setItem('kycPopupDismissed', '1');
              setShowKycPopup(false);
            }}
            aria-label="Close Modal"
            type="button"
            tabIndex={0}
            role="button"
            onKeyDown={() => {
              sessionStorage.setItem('kycPopupDismissed', '1');
              setShowKycPopup(false);
            }}
          />
        </div>
        <div
          className={`${style.Modal__Body} cs_modal_body`}
          style={{
            paddingBottom: (source === 53 || source === '53') && version >= 3.3 ? 120 : 20,
          }}
        >
          <div className={`${style.ImageBox}`}>
            <img
              alt="EcsInactive"
              className=""
              src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/kyc_update_popup.svg"
              width={160}
              height={123}
            />
          </div>
          <div className="font16 fw600 color111 mt-20">Your KYC status is pending</div>

          <button
            onClick={handleKycRedirect}
            type="button"
            className={`${style.Button} bluefill_animate font14 fw600 colorFFF mt-20`}
          >
            Update KYC details
          </button>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => {
              sessionStorage.setItem('kycPopupDismissed', '1');
              setShowKycPopup(false);
            }}
            className={`${style.AnchorGroup} mt-15`}
          >
            <span className="font13 fw400 color777 pointer">I’ll do it later</span>
          </div>
        </div>
      </div>
    </section>
  );
};
export default KycPendingModal;
KycPendingModal.propTypes = {
  setShowKycPopup: PropTypes.func,
  handleKycRedirect: PropTypes.func,
};
